import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Modal = styled.div`
  width: 95%;
  height: 95%;
  border: 0;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: #ffffff;
  box-shadow: 0px 3px 4px 0px #00000040;
  display: flex;
  justify-content: space-between;
`

export const ChildrenContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  height: 100%;
  padding: 50px;
  display: flex;
  flex-direction: column;
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;

  ::-webkit-scrollbar-track {
    background-color: #f4f4f4;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f4f4f4;
  }
  ::-webkit-scrollbar-thumb {
    background: #dad7d7;
  }
`

export const Background = styled.div`
  z-index: 205;
  background: #00000026;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PathContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  max-height: 24px;

  margin-bottom: 20px;

  .close-modal {
    width: 24px;
    height: 24px;
  }

  .path {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: #9c948c;

    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.14px;
  }
`
export const PixButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  /* align-self: flex-end; */

  width: 154px;
  height: 40px;

  border: none;

  font-family: ${Theme.fontFamily.SECONDARY};

  cursor: pointer;

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  /* line-height: 20px; */

  border-radius: 5px;

  background: ${Theme.pallete.TERTIARY};
  color: white;

  &:hover {
    background: ${Theme.pallete.TERTIARY2};
  }

  &:focus {
    fill: ${Theme.pallete.TERTIARY2};
    stroke-width: 1px;
    stroke: ${Theme.pallete.TERTIARY2};
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);
    background: ${Theme.pallete.TERTIARY2};
  }

  &:disabled {
    background: ${Theme.pallete.SECONDARY3};
    color: ${Theme.pallete.QUATERNARY};
    cursor: not-allowed;
  }

  .loading-img-btn {
    width: 18px;
    height: 18px;
    /* top: 20px;
    right: 20px; */
    /* position: absolute; */
    animation: load 2s infinite linear;
  }

  .default-btn-img {
    max-width: 14px;
    max-height: 14px;
    margin-right: 5px;
    filter: ${(props: any) => {
      if (props.disabled) return `${Theme.icons.PRIMARY}`
      return 'brightness(0) invert(1)'
    }};
    @media only screen and (min-width: 1441px) {
      max-width: 18px;
      max-height: 18px;
      margin-right: 6px;
    }
  }

  @media only screen and (min-width: 1441px) {
    height: 45px;
    width: 162px;
    font-size: 13px;
  }
`
export const Simulation = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  }

  .d-icons {
    width: 16px;
    height: 16px;
    margin-left: 16px;
    cursor: pointer;
  }

  .loading-img-btn {
    width: 18px;
    height: 18px;
    /* top: 20px;
    right: 20px; */
    /* position: absolute; */
    animation: load 2s infinite linear;
  }

  .big-pdf-button {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    width: 315px;
    height: 56px;
    padding: 16px;
    border-radius: 5px;
    background-color: #6d6d6d;
  }

  .big-pdf-icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }
`
export const PixContainer = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`
